import { render } from "./ExpandableSection.vue?vue&type=template&id=2fcca340"
import script from "./ExpandableSection.vue?vue&type=script&lang=js"
export * from "./ExpandableSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__